<template>
	<div class="alls">
		<!-- 头部 -->
		<b-container class=" bv-example-row">
			<b-row>
				<b-col cols="12">
					<div class="title mt-6">
						<div class="title-text">Special training camp</div>
						<div class="title-name">四六级特训营 +</div>
						<div class="title-welcome">
							<span>欢迎加入我们</span>
							<span>WELCOME</span>
						</div>
					</div>
				</b-col>
			</b-row>
			<!-- 列表 -->
			<b-row align-h="center">
				<b-col class="subject" cols="12" md="5" lg="5" xl="5">
					<img class="subject-img" src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/eg8.png" alt="" />
					<img class="cet-logo" src="../../images/cet-logo.png" alt="" />
				</b-col>
				<b-col class="subject" cols="12" md="5" lg="5" xl="5">
					<img src="../../images/cet-bg.png" alt="" />
					<div class="subject-content">
						<div>四级暑期特训营 - 备考12月</div>
						<div>一</div>
						<div>考前抢分，灵活上课</div>
						<div class="subject-price">
							<span><span style="font-size: 16px;">¥ </span> 69</span>
							<span>原价¥199</span>
						</div>
						<div class="go-detail" @click="gocoursedetails(4)">
							查看详情
							<span class="gt"><img src="../../images/gt.svg" alt="" /></span>
						</div>
					</div>
				</b-col>
			</b-row>
			<!-- 列表 -->
			<b-row align-h="center">
				<b-col class="subject" cols="12" md="5" lg="5" xl="5">
					<!-- 	<b-img  src="../../images/eg9.png" fluid-grow  alt = “响应图像”> </b-img> 	 -->
					<img class="subject-img" src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/eg9.png" alt="" />
					<img class="cet-logo" src="../../images/cet-logo.png" alt="" />
				</b-col>
				<b-col class="subject" cols="12" md="5" lg="5" xl="5">
					<img src="../../images/cet-bg.png" alt="" />
					<div class="subject-content">
						<div>六级暑期特训营 - 备考21年6月</div>
						<div>一</div>
						<div>
							考前抢分，灵活上课
							<img style="width: 1rem!important;margin-left:0.3125rem;" src="../../images/medal.png" alt="" />
						</div>
						<div class="subject-price">
							<span><span style="font-size: 16px;">¥ </span> 69</span>
							<span>原价¥199</span>
						</div>
						<div class="go-detail" @click="gocoursedetails(5)">
							查看详情
							<span class="gt"><img src="../../images/gt.svg" alt="" /></span>
						</div>
					</div>
				</b-col>
			</b-row>
			<!-- 咨询 -->
			<b-row>
				<b-col cols="12">
					<div class="title consulting mt-6">
						<div class="title-text">You need to ask us?</div>
						<div class="title-name">你需要问我们什么？</div>
						<div class="title-welcome">
							<span>四六级咨询</span>
							<span>CONSULTING</span>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-row align-h="center" class="list">
				<b-col cols="12" md="10" lg="10" xl="10" class="consulting-list">
					<div class="qa">Q/A</div>
					<!-- 咨询列表 -->
					<b-row class="list-content">
						<b-col cols="12" md="5" lg="5" xl="5" class="d1"><img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/cet-consulting1.png" alt="" /></b-col>
						<b-col cols="12" md="5" lg="7" xl="7" class="d2">
							<div class="listcontent-top">
								<div class="listcontent-left">
									<img src="../../images/true.png" alt="" />
									<span>【冲刺必备】万能写作模板，掌握诀窍拿高分！</span>
								</div>
								<div class="look-detail">
									<!-- <a href="https://mp.weixin.qq.com/s/BpH8a8GGa5Vkdir0kiw3MQ" target="_blank">
										<span>查看详情</span>
										<img src="../../images/backgt.png" alt="" />
									</a> -->
								</div>
							</div>
							<div class="l-detail">
								在四六级写作中，我们常常要根据审题的结果来决定文章的主体段到底要采用哪种论证方式，不管是提纲类，情景类，图画类，还是应用文类型，在写作时，都会用到三大类最常考的论证方式：原因分析，对比选择以及问题解决。
								下面我们就常考的作文类型来进行模板分析。
							</div>
						</b-col>
					</b-row>
					<!-- 咨询列表 -->
					<b-row class="list-content">
						<b-col cols="12" md="5" lg="5" xl="5" class="d1"><img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/cet-consulting2.png" alt="" /></b-col>
						<b-col cols="12" md="5" lg="7" xl="7" class="d2">
							<div class="listcontent-top">
								<div class="listcontent-left">
									<img src="../../images/true.png" alt="" />
									<span>【救命干货】听力闹钟词来了，背了听力就有救！</span>
								</div>
								<div class="look-detail">
									<!-- <a href="https://mp.weixin.qq.com/s/JHpYbm5or1P42xkwuEWLZw" target="_blank">
										<span>查看详情</span>
										<img src="../../images/backgt.png" alt="" />
									</a> -->
								</div>
							</div>
							<div class="l-detail">
								听力一直都是好多同学的老大难，要怎么才能听得懂呢？闹钟词是必不可少的，一旦听到这些词语你就能大概知道这段对话讲的内容，而且答案都会在里面。所以闹钟词是一定要记住的，加油吧小伙伴们！
							</div>
						</b-col>
					</b-row>
					<!-- 咨询列表 -->
					<!-- <b-row class="list-content">
						<b-col cols="12" md="5" lg="5" xl="5" class="d1"><img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/cet-consulting3.png" alt="" /></b-col>
						<b-col cols="12" md="5" lg="7" xl="7" class="d2">
							<div class="listcontent-top">
								<div class="listcontent-left">
									<img src="../../images/true.png" alt="" />
									<span>好气!!!怎么还过不了四六级？</span>
								</div>
								<div class="look-detail">
									<a href="https://mp.weixin.qq.com/s/_zFeca4x0qkTMVm9u1kLnA" target="_blank">
										<span>查看详情</span>
										<img src="../../images/backgt.png" alt="" />
									</a>
								</div>
							</div>
							<div class="l-detail">
								四六级成绩公布已经过去几天了，可以说是有人欢喜有人愁，看着大家晒出自己漂亮的成绩单，也会有同学发出疑问：为什么我考了好几次，还是过不了四六级？
							</div>
						</b-col>
					</b-row> -->
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
export default {
	name: 'App',
	created() {},
	methods: {
		back() {
			this.$router.push('/');
		},
		go() {
			this.$router.push('/cet');
		},
		gocoursedetails(type) {
			//课程详情
			console.log(navigator.userAgent);
			let os = (function() {
				let ua = navigator.userAgent,
					isWindowsPhone = /(?:Windows Phone)/.test(ua),
					isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
					isAndroid = /(?:Android)/.test(ua),
					isFireFox = /(?:Firefox)/.test(ua),
					isChrome = /(?:Chrome|CriOS)/.test(ua),
					isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
					isPhone = /(?:iPhone)/.test(ua) && !isTablet,
					isPc = !isPhone && !isAndroid && !isSymbian;
				return {
					isTablet: isTablet,
					isPhone: isPhone,
					isAndroid: isAndroid,
					isPc: isPc
				};
			})();
			/*
					if(os.isAndroid || os.isPhone) { //手机
					  window.location.href="https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=69";
					} else if(os.isTablet) { //ipad
					  window.location.href="https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=69";
					} else */
			if (os.isPc) {
				//pc端
				this.$store.commit('change', type);
				sessionStorage.setItem('type', type);
				console.log(sessionStorage.getItem('type'));
				this.$router.push('/coursedetails/coursedetails');
			} else {
				if (type == 0) {
					window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=69';
				} else if (type == 1) {
					window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=ielts_mini_course';
				} else if (type == 2) {
					window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=ielts_class_course';
				} else if (type == 3) {
					window.location.href = 'https://app.honeybee-edu.com/h5/pages/contens/index/index?typesting=ielts_1v1_course';
				} else if (type == 4) {
					window.location.href = 'https://youke.honeybee-edu.com/h5';
				} else if (type == 5) {
					window.location.href = 'https://youke.honeybee-edu.com/h5';
				}
			}
		}
	}
};
</script>

<style>
.go-detail,
.look-detail {
	cursor: pointer;
}
.l-detail {
	margin-top: 2.8125rem;
	font-size: 1rem;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	overflow: hidden;
	margin-bottom: 1.25rem;
	text-align: left;
}
.look-detail span {
	font-size: 0.75rem !important;
	font-weight: 400 !important;
}
.look-detail img {
	width: 0.59375rem !important;
	height: 0.59375rem !important;
	margin-left: 0.3125rem;
}
.listcontent-top {
	display: flex;
	justify-content: space-between;
	/* 	margin-top: 1.25rem; */
}
.listcontent-top img {
	width: 1.375rem;
	height: 1.125rem;
}
.listcontent-left {
	max-width: 70%;
}
.listcontent-top span {
	font-size: 1.125rem;
	font-weight: bolder;
	color: #000000;
}
.list-content {
	margin-top: 1.875rem;
	padding-bottom: 1.25rem;
}
.d1,
.d2 {
	width: 100%;
}
.d1 img {
	width: 90%;
	max-height: 15rem;
	margin: 0 auto;
}
.qa {
	width: 4.0625rem;
	height: 4.0625rem;
	border-radius: 50%;
	background-color: #28352c;
	font-size: 1.4375rem;
	font-weight: 400;
	color: #eeeeee;
	line-height: 4.0625rem;
	margin: -2rem auto 0 auto;
}
.consulting-list {
	background-color: #eeeeee;
	position: relative;
}
* {
	font-family: 'pictograph';
}
.alls {
	width: 100%;
	overflow: hidden;
}
.mt-6 {
	margin-top: 3rem !important;
}
.mt-8 {
	margin-top: 5rem !important;
}
.mt-10 {
	margin-top: 7rem !important;
}
.title {
	margin: 0 auto 4.3125rem auto;
	text-align: left;
	display: inline-block;
}
.title-text {
	/* 	font-size: 12px;
	transform: scale(0.7);
	margin-left: -23px; */
	font-size: 0.75rem;
	font-family: FZLanTingHei-DB-GBK;
	color: #28352c;
	transform: scale(0.7);
	margin-left: -1.875rem;
}
.title-name {
	font-weight: bold;
	font-size: 1.5rem;
}
.title-welcome {
	margin-top: 0.625rem;
}
.title-welcome span:nth-child(1) {
	background: #28352c;
	box-shadow: 0.1875rem 0.3125rem 0.5625rem 0.0625rem rgba(0, 0, 0, 0.31);
	border-radius: 0.3125rem;
	color: #ffffff;
	padding: 0.3125rem 0.5625rem;
}
.title-welcome span:nth-child(2) {
	color: #000000;
	font-size: 0.75rem;
	font-weight: bold;
	margin-left: 0.5rem;
}
.subject {
	padding: 0 !important;
	position: relative;
	margin-bottom: 3rem;
}
.subject img {
	width: 100%;
}
.subject-img {
	object-fit: cover;
	height: 100%;
}
.cet-logo {
	position: absolute;
	top: 1rem;
	left: 1rem;
	width: 2.225rem !important;
}
.subject-content {
	position: absolute;
	padding-left: 1.75rem;
	bottom: 0;
	width: 100%;
	text-align: left;
}
.subject-content div:nth-child(1) {
	font-size: 1.2375rem;
	font-weight: 400;
	color: #f2c52d;
}
.subject-content div:nth-child(2) {
	font-size: 1.4375rem;
	font-weight: 400;
	color: #f2c52d;
}
.subject-content div:nth-child(3) {
	font-size: 0.8125rem;
	font-weight: 400;
	color: #f2c52d;
	margin-bottom: 0.8125rem;
}

.subject-price span:nth-child(1) {
	font-size: 1.3125rem;
	font-weight: 400;
	color: #f2c52d;
}
.subject-price span:nth-child(2) {
	font-size: 0.625rem;
	font-weight: 500;
	color: #ffffff;
	text-decoration: line-through;
	margin-left: 2.875rem;
}
.subject-content div:nth-child(5) {
	margin-top: 1rem;
	margin-bottom: 1.6875rem;
	font-size: 0.6875rem;
	font-weight: 400;
	color: #ffffff;
	display: flex;
}

.gt {
	width: 1rem;
	height: 1rem;
	margin-left: 0.95rem;
	display: block;
	text-align: center;
	margin-top: -0.15rem;
}
.gt img {
	width: 100%;
	height: 100%;
}

.consulting {
	margin-top: 0 !important;
}

/* 小屏幕（平板，大于等于 768px） */
@media (min-width: @screen-sm-min) {
	.mt-6 {
		margin-top: 3rem !important;
	}
	.mt-8 {
		margin-top: 5rem !important;
	}
	.mt-10 {
		margin-top: 8rem !important;
	}
	.subject-price span:nth-child(1) {
		font-size: 1.3125rem;
	}
	.subject {
		margin-bottom: 5rem;
	}
	.subject-content {
		padding-left: 3.75rem;
	}

	.subject-price {
		margin-bottom: 3.75rem;
	}

	.subject-price span:nth-child(2) {
		margin-left: 2.875rem;
	}
	.subject-content div:nth-child(5) {
		margin-bottom: 2.6875rem;
	}
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: @screen-md-min) {
	.mt-6 {
		margin-top: 6rem !important;
	}
	.mt-8 {
		margin-top: 8rem !important;
	}
	.mt-10 {
		margin-top: 10rem !important;
	}
	.subject {
		margin-bottom: 5rem;
	}
	.subject-content {
		padding-left: 3.75rem;
	}

	.subject-price {
		margin-bottom: 3.75rem;
	}

	.subject-price span:nth-child(2) {
		margin-left: 2.875rem;
	}
	.subject-content div:nth-child(5) {
		margin-bottom: 2.6875rem;
	}
}

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) {
	.mt-6 {
		margin-top: 6rem !important;
	}
	.mt-8 {
		margin-top: 8rem !important;
	}
	.mt-10 {
		margin-top: 10rem !important;
	}
	.subject {
		margin-bottom: 5rem;
	}
	.subject-content {
		padding-left: 3.75rem;
	}

	.subject-price {
		margin-bottom: 3.75rem;
	}

	.subject-price span:nth-child(2) {
		margin-left: 2.875rem;
	}
	.subject-content div:nth-child(5) {
		margin-bottom: 2.6875rem;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/cet/cet.vue